import Modal from '../../components/Modal';

import SelectorEngine from '../../utils/dom/selector-engine';
import Request from '../../utils/request';

class AccountDetailsVenues {
	constructor() {
		this.state = {
			changes: {}
		};
		this._wrapper = undefined;
		this._hasChanges = undefined;
		this._submitCta = undefined;
		this._cancelCta = undefined;
		this._exitModal = undefined;
		this._saveModal = undefined;
		this._errorWrapper = undefined;
		this._backButton = undefined;

		this._saveContinue = undefined;
		this._saveCancel = undefined;

		this.initiateVenuesEdit();
	}

	initiateVenuesEdit() {
		this._wrapper = SelectorEngine.findOne('.p-account-details__venues');

		if (this._wrapper !== null) {
			this._submitCta = SelectorEngine.findOne('.js-account-save-venues', this._wrapper);
			this._submitCta.addEventListener('click', () => this._saveModal.show());

			this._exitModal = new Modal(SelectorEngine.findOne('#exit-editing'), {});
			this._saveModal = new Modal(SelectorEngine.findOne('#venues__save-changes'), {});

			this._errorWrapper = SelectorEngine.findOne('.p-account-details__submission-error');
			const errorCloseCta = SelectorEngine.findOne('.js-dismiss-account-submission--error', this._errorWrapper);
			errorCloseCta.addEventListener('click', () => {
				this._errorWrapper.classList.add('u-hidden');
			});

			this._backButton = SelectorEngine.findOne('.js-account-edit-back');
			this._backButton.addEventListener('click', (event) => {
				this.exitEditing(event);
			});

			this._cancelCta = SelectorEngine.findOne('.js-account-exit', this._wrapper);
			this._cancelCta.addEventListener('click', (event) => this.exitEditing(event));

			this._wrapper.addEventListener('change', (event) => this.toggleSubmit(event));

			const popupCancel = SelectorEngine.findOne('.js-account-details-continue');
			popupCancel.addEventListener('click', () => this._exitModal.hide());

			const popupContinue = SelectorEngine.findOne('.js-account-details-exit');
			popupContinue.addEventListener('click', (event) => this.backToUrl(event));

			this._saveCancel = SelectorEngine.findOne('.js-venues-details-cancel', this._wrapper);
			this._saveCancel.addEventListener('click', () => this._saveModal.hide());

			this._saveContinue = SelectorEngine.findOne('.js-venues-details-continue', this._wrapper);
			this._saveContinue.addEventListener('click', (event) => this.submitChanges(event));
		}
	}

	toggleSubmit(event) {
		if (event.detail && event.detail !== null) {
			this.state.changes = event.detail;
			const { add, remove } = event.detail;
			this._hasChanges = (add.length > 0 || remove.length > 0) ? true : false;
			if (this._hasChanges) {
				this._submitCta.classList.remove('u-hidden');
			} else {
				this._submitCta.classList.add('u-hidden');
			}
		}
	}

	async submitChanges(event) {
		this._saveContinue.disabled = true;
		this._saveCancel.disabled = true;

		const url = event.currentTarget.dataset.target;
		const data = this.state.changes;
		const formattedData = {
			addVenueIds: data.add.map((venue) => ({
				venueId: venue.venueId,
				paymentType: venue.paymentType
			})),
			deleteVenueIds: data.remove.map((venue) => venue.venueId)
		};
		const submittedData = await Request.post('/api/account/venues', formattedData)
			.catch(() => {
				this._saveModal.hide();
				this._errorWrapper.classList.remove('u-hidden');
			});

		this._saveContinue.disabled = false;
		this._saveCancel.disabled = false;
		if (submittedData) {
			this.backToUrl(null, url);
		}
	}

	exitEditing(event) {
		if (this._hasChanges) {
			this._exitModal.show();
		} else {
			this.backToUrl(event);
		}
	}

	backToUrl(event, redirectUrl = null) {
		const rootUrl = window.location.origin
		const url = redirectUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}
}

const globalAccountDetailsVenues = new AccountDetailsVenues();

export default globalAccountDetailsVenues;
